import React, {useEffect, useState} from "react";
import {Link, useNavigate} from "react-router-dom";

const logo = require("./../assets/img/logo2.svg").default;
const user = require("./../assets/img/person.png");
const toggle = require("./../assets/img/menu-btn.svg").default;

const Header = ({userData}) => {
  const navigate = useNavigate();
  const [accountShowPopup, AccountsetShowPopup] = useState(false);
  const [notificationShowPopup, NotificationsetShowPopup] = useState(false);
  const [notificationDetails, setNotificationDetails] = useState();

  const handleFilterButtonClick = () => {
    AccountsetShowPopup(prevaccountShowPopup => !prevaccountShowPopup);
  };
  const handleNotificationButtonClick = () => {
    NotificationsetShowPopup(prevnotificationShowPopup => !prevnotificationShowPopup);
  };

  const handleLogout = () => {
    // Perform logout action here, such as clearing user data from local storage
    localStorage.removeItem("userData");
    // Redirect to the login page after logout
    navigate("/");
  };

  const fetchNotificationsCount = () => {
    const storedUserData = JSON.parse(localStorage.getItem("userData"));

    // Construct the URL with from_date and to_date parameters

    fetch(`https://cliqestimatebuilder.com/waiver_admin/notifications/count/`, {
      headers: {
        Authorization: `Bearer ${storedUserData.token}`,
      },
      method: "GET",
    })
      .then(response => response.json())
      .then(data => {
        if (data.res == 1) {
          setNotificationDetails(data.data);
        }
      })
      .catch(error => console.error("Error fetching file data:", error));
  };

  useEffect(() => {
    const timer = setInterval(() => {
      // Call the API function
      fetchNotificationsCount();
    }, 6000); // 6000 milliseconds = 6 seconds

    // Clear the timer when the component unmounts
    return () => {
      clearInterval(timer);
    };
  }, []);

  useEffect(() => {
    fetchNotificationsCount();
  }, []);

  return (
    <div className="header">
      <div className="logoDiv">
        <h2>Waiver Bill</h2>
      </div>

      <div className="headerRight">
        <div className="bellDiv" onClick={handleNotificationButtonClick}>
          <span>{notificationDetails?.notification_count}</span>
          {notificationShowPopup && (
            <div className="notificationPopup">
              {notificationDetails?.notifications?.length > 0 ? (
                <ul>
                  {notificationDetails?.notifications?.map((item, index) => (
                    <li key={index}>
                      <h4>{item?.created_at}</h4>
                      {item?.message}
                    </li>
                  ))}
                  <li>
                    <Link to="/notifications">View All</Link>
                  </li>
                </ul>
              ) : (
                <ul>
                  <li>No notifications found.</li>
                  <li>{/* <Link to="/notifications">View All</Link> */}</li>
                </ul>
              )}
            </div>
          )}
        </div>
        <div className="userDiv" onClick={handleFilterButtonClick}>
          <span>{userData && userData.name}</span>
          {/* <img src={userData?.avatar ? `https://cliqestimatebuilder.com/waiver_admin/${userData.avatar}` : user} alt="image" /> */}
          <img src={user} alt="image" />
          {accountShowPopup && (
            <div className="accountPopup">
              <ul>
                <li>
                  <Link to="/change-password">Change Password</Link>
                </li>
                <li>
                  <a onClick={handleLogout}>Logout</a>
                </li>
              </ul>
            </div>
          )}
        </div>
        <div className="mobileBtn">
          <img src={toggle} alt="image" />
        </div>
      </div>
    </div>
  );
};

export default Header;
